const STORAGE_KEY = 'choix-theme';

/**
 * @returns {'light' | 'dark'}
 */
export function getTheme() {
  const theme = document.documentElement.getAttribute('data-theme');
  return theme === 'dark' ? 'dark' : 'light';
}

/**
 * @param {'light' | 'dark'} theme
 */
export function setTheme(theme) {
  const next = theme === 'dark' ? 'dark' : 'light';
  document.documentElement.setAttribute('data-theme', next);
  document.documentElement.style.colorScheme = next;

  try {
    localStorage.setItem(STORAGE_KEY, next);
  } catch {
    /* private browsing */
  }

  syncToggleControls(next);
  document.dispatchEvent(new CustomEvent('choix:theme-change', { detail: { theme: next } }));
}

export function toggleTheme() {
  setTheme(getTheme() === 'dark' ? 'light' : 'dark');
}

/**
 * @param {'light' | 'dark'} theme
 */
function syncToggleControls(theme) {
  document.querySelectorAll('[data-choix-theme-toggle]').forEach((control) => {
    const isDark = theme === 'dark';
    control.setAttribute('aria-pressed', String(isDark));
    const label = isDark ? control.dataset.labelLight : control.dataset.labelDark;
    if (label) control.setAttribute('aria-label', label);
  });
}

document.addEventListener('click', (event) => {
  const control = event.target.closest('[data-choix-theme-toggle]');
  if (!control) return;
  event.preventDefault();
  toggleTheme();
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => syncToggleControls(getTheme()));
} else {
  syncToggleControls(getTheme());
}
